module.exports = __webpack_public_path__ + "da6cd3aa3809c5256875dbdabcd6acaa.png";